import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { ReservedTicketsComponent } from './reserved-tickets.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ReservedTicketsComponent],
    imports: [
        SharedModule,
        TranslateModule
    ]
})
export class ReservedTicketsModule {
}

